<div class="container-fluid py-4">
  <div class="row mb-4 justify-content-center">
    <ng-container *ngFor="let card of resumenCards; index as i">
      <div class="col-3 col-md-2">
        <div
          class="card card-stats initial-card"
          [ngClass]="{ 'card-stats__selected': i === 0 }"
          [routerLink]="card.route"
          [style.cursor]="card.route || i === 0 ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow icon-card"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>

              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>

          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>

      <!-- SALTO DE FILA después de la 4ta tarjeta (i = 3) -->
      <div *ngIf="i === 3" class="w-100"></div>
    </ng-container>
  </div>

  <div class="row mb-6 mt-4">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/metricsDaily']"
        >
          Metrics daily
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/metricsWeekly']"
        >
          Metrics weekly
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/actionsBacklog']"
        >
          Actions backlog
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/cannibalClusters']"
        >
          Cannibal clusters
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/keywordInsights']"
        >
          Keyword insights
        </a>
      </div>
    </div>
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-light btn-sm btn-new"
          [routerLink]="['/observability/seo/cannibalEdges']"
        >
          Cannibal edges
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/localSeo/reviews']"
        >
          Reviews
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/technicalAudits']"
        >
          Technical Audits
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/sitemapAudits']"
        >
          Sitemap Audits
        </a>
        <a class="btn btn-dark btn-sm btn-reg"> Off-page </a>
      </div>
    </div>
  </div>

  <br />

  <div class="row">
    <!-- Summary Cards -->
    <div class="col-lg-3 col-md-6 col-sm-6">
      <div class="card card-stats filter">
        <div class="card-header card-header-info card-header-icon">
          <div class="card-icon">
            <i class="material-icons">assessment</i>
          </div>
          <p class="card-category">Evaluated</p>
          <h3 class="card-title">{{ summary.total }}</h3>
        </div>
      </div>
    </div>
    <div class="col-lg-2 col-md-4 col-sm-4">
      <div class="card card-stats filter">
        <div class="card-header card-header-success card-header-icon">
          <div class="card-icon">
            <i class="material-icons">done_all</i>
          </div>
          <p class="card-category">Excellent</p>
          <h3 class="card-title">{{ summary.excellent }}</h3>
        </div>
      </div>
    </div>
    <div class="col-lg-2 col-md-4 col-sm-4">
      <div class="card card-stats filter">
        <div class="card-header card-header-primary card-header-icon">
          <div class="card-icon">
            <i class="material-icons">thumb_up</i>
          </div>
          <p class="card-category">Good</p>
          <h3 class="card-title">{{ summary.good }}</h3>
        </div>
      </div>
    </div>
    <div class="col-lg-2 col-md-4 col-sm-4">
      <div class="card card-stats filter">
        <div class="card-header card-header-warning card-header-icon">
          <div class="card-icon">
            <i class="material-icons">visibility</i>
          </div>
          <p class="card-category">Watch</p>
          <h3 class="card-title">{{ summary.watch }}</h3>
        </div>
      </div>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-6">
      <div class="card card-stats filter">
        <div class="card-header card-header-danger card-header-icon">
          <div class="card-icon">
            <i class="material-icons">report_problem</i>
          </div>
          <p class="card-category">Poor</p>
          <h3 class="card-title">{{ summary.poor }}</h3>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header card-header-info">
          <div class="row">
            <div class="col-md-6">
              <h4 class="card-title">Off-Page Performance</h4>
              <p class="card-category">
                Live campaign health and attribution metrics
              </p>
            </div>
            <div class="col-md-6 text-right">
              <button
                mat-raised-button
                class="btn btn-white btn-round btn-just-icon"
                (click)="runAttribution()"
                [disabled]="loading"
                matTooltip="Run Attribution Logic"
              >
                <i class="material-icons">play_arrow</i>
                <div class="ripple-container"></div>
              </button>
              <button
                mat-raised-button
                class="btn btn-white btn-round btn-just-icon"
                (click)="loadPerformance()"
                [disabled]="loading"
                matTooltip="Refresh"
              >
                <i class="material-icons">refresh</i>
                <div class="ripple-container"></div>
              </button>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div *ngIf="loading" class="text-center">
            <mat-spinner diameter="40" style="margin: 20px auto"></mat-spinner>
          </div>

          <div class="table-responsive" *ngIf="!loading">
            <table mat-table [dataSource]="performanceList" class="table">
              <ng-container matColumnDef="campaign">
                <th mat-header-cell *matHeaderCellDef class="thead">
                  Campaign
                </th>
                <td
                  class="url-cell"
                  (click)="showModal('Campaign', element.campaignId.title)"
                  title="Click to view full Campaign"
                  mat-cell
                  *matCellDef="let element"
                >
                  {{ element.campaignId.title }}
                  <br />
                  <small
                    >{{ element.campaignId.city }} -
                    {{ element.campaignId.service }}</small
                  >
                </td>
              </ng-container>

              <ng-container matColumnDef="keyword">
                <th mat-header-cell *matHeaderCellDef class="thead">
                  Keywords
                </th>
                <td
                  class="url-cell"
                  mat-cell
                  *matCellDef="let element"
                  (click)="showModal('Keywords', getKeywords(element))"
                  title="Click to view all keywords"
                >
                  <div *ngIf="getKeywords(element).length > 0; else noKw">
                    {{ getKeywords(element)[0] }}
                    <small
                      *ngIf="getKeywords(element).length > 1"
                      class="text-muted"
                    >
                      (+{{ getKeywords(element).length - 1 }})
                    </small>
                  </div>
                  <ng-template #noKw>-</ng-template>
                </td>
              </ng-container>

              <ng-container matColumnDef="url">
                <th mat-header-cell *matHeaderCellDef class="thead">URL</th>
                <td mat-cell *matCellDef="let element">
                  <a
                    [href]="element.targetUrl"
                    target="_blank"
                    class="text-info"
                  >
                    <i class="material-icons" style="font-size: 16px"
                      >open_in_new</i
                    >
                  </a>
                </td>
              </ng-container>

              <ng-container matColumnDef="prospects">
                <th mat-header-cell *matHeaderCellDef class="thead">
                  Prospects
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.prospectsTotal }}
                </td>
              </ng-container>

              <ng-container matColumnDef="published">
                <th mat-header-cell *matHeaderCellDef class="thead">
                  Published
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.prospectsPublished }}
                  <small
                    >({{ (element.conversionRate * 100).toFixed(1) }}%)</small
                  >
                </td>
              </ng-container>

              <ng-container matColumnDef="backlinks">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  class="thead general-cell"
                >
                  Backlinks Live
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  class="text-success font-weight-bold"
                >
                  {{ element.backlinksLiveCount }}
                </td>
              </ng-container>

              <ng-container matColumnDef="referringDomains">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  class="thead general-cell"
                >
                  Ref. Domains
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.referringDomainsCount }}
                </td>
              </ng-container>

              <ng-container matColumnDef="positionDelta">
                <th mat-header-cell *matHeaderCellDef class="thead">
                  Position Δ
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  [ngClass]="
                    element.positionDelta > 0
                      ? 'text-success'
                      : element.positionDelta < 0
                        ? 'text-danger'
                        : ''
                  "
                >
                  {{ element.positionDelta > 0 ? "+" : ""
                  }}{{ element.positionDelta.toFixed(2) }}
                </td>
              </ng-container>

              <ng-container matColumnDef="clicksDelta">
                <th mat-header-cell *matHeaderCellDef class="thead">
                  Clicks Δ
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  [ngClass]="
                    element.clicksDelta > 0
                      ? 'text-success'
                      : element.clicksDelta < 0
                        ? 'text-danger'
                        : ''
                  "
                >
                  {{ element.clicksDelta > 0 ? "+" : ""
                  }}{{ element.clicksDelta }}
                </td>
              </ng-container>

              <ng-container matColumnDef="impactScore">
                <th mat-header-cell *matHeaderCellDef class="thead">Impact</th>
                <td mat-cell *matCellDef="let element">
                  <span class="badge badge-info">{{
                    element.impactScore
                  }}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="health">
                <th mat-header-cell *matHeaderCellDef class="thead">Health</th>
                <td mat-cell *matCellDef="let element">
                  <span
                    class="badge"
                    [ngClass]="{
                      'badge-success': element.healthStatus === 'excellent',
                      'badge-primary': element.healthStatus === 'good',
                      'badge-warning': element.healthStatus === 'watch',
                      'badge-danger': element.healthStatus === 'poor',
                    }"
                    >{{ element.healthStatus | uppercase }}</span
                  >
                </td>
              </ng-container>

              <ng-container matColumnDef="confidence">
                <th mat-header-cell *matHeaderCellDef class="thead">
                  Confidence
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.attributionConfidence | titlecase }}
                </td>
              </ng-container>

              <ng-container matColumnDef="lastSnapshot">
                <th mat-header-cell *matHeaderCellDef class="thead">
                  LastSnapshot
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.lastSnapshotAt | date: "mediumDate" }}
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="thead"></th>
                <td mat-cell *matCellDef="let element">
                  <button
                    mat-raised-button
                    type="button"
                    class="btn btn-info btn-link btn-just-icon"
                    [routerLink]="[
                      '/observability/seo/offPagePerformance',
                      element.campaignId._id,
                    ]"
                  >
                    <i class="material-icons">visibility</i>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                *matRowDef="let element; columns: displayedColumns"
              ></tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div
  class="modal-url-overlay"
  *ngIf="modalContent || modalListItems"
  (click)="closeModal()"
>
  <div class="modal-url-content" (click)="$event.stopPropagation()">
    <div class="modal-url-header">
      <h5 class="mb-0">{{ modalTitle }}</h5>
      <button type="button" class="modal-url-close" (click)="closeModal()">
        &times;
      </button>
    </div>
    <div
      class="modal-url-body text-dark"
      style="word-wrap: break-word; white-space: pre-wrap"
    >
      <ng-container *ngIf="modalContent">
        {{ modalContent }}
      </ng-container>
      <ul *ngIf="modalListItems" class="ps-3 mb-0">
        <li *ngFor="let item of modalListItems" style="padding-bottom: 4px">
          {{ item }}
        </li>
      </ul>
    </div>
  </div>
</div>
